export const ProgramWeekVideos = {
  bindings: {
    weekNumber: '<',
    items: '<',
    videoResume: '<',
  },

  template: `
    <div class="container program-week-videos">
      <section class="section-carousel">
        <h4>
          <span class="aside">
            Week {{ $ctrl.weekNumber }}
          </span>
          Videos
        </h4>
        <carousel
          list="$ctrl.items"
          settings="{ slidesToShow: 3 }"
          ng-if="$ctrl.items">
          <div class="carousel-slide-wrapper"
            ng-repeat="item in $ctrl.items track by item.id">
            <div class="carousel-slide">
              <card-video
                image="item.thumbnailUrl.large"
                data-toggle="modal"
                data-target="#modalVideoProgram"
                on-click="$ctrl.loadModalVideo(item)">
              </card-video>
            </div>
          </div>
        </carousel>
      </section>
      <modal
        size="lg"
        target="modalVideoProgram"
        on-hidden="$ctrl.onHideModal()">
        <modal-title>
          <span class="text-center">{{ $ctrl.modalTitle }}</span>
        </modal-title>
        <modal-body>
          <video-player-resumable
            on-load="$ctrl.onLoadPlayer(player)"
            autoplay="!this.videoResume[this.modalVideoId]"
            video-id="$ctrl.modalVideoId">
          </video-player-resumable>
        </modal-body>
      </modal>
    </div>`,

  controller() {
    'ngInject';

    return {
      loadModalVideo(item) {
        this.modalTitle = item.title;
        this.modalVideoId = item.brightcoveId;
      },

      onLoadPlayer(player) {
        this.player = player;

        if (!this.videoResume[this.modalVideoId]) {
          this.player.play();
        }
      },

      onHideModal() {
        if (this.player) {
          this.player.pause();
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Program/ProgramWeekVideos.js